export default __webpack_public_path__ + "static/media/are-you-idiot-78.a421ebf2.png";